import React from 'react'
import { PromptProps as ReactRouterPromptProps } from 'react-router-dom'
import { Prompt } from 'react-router-dom'

export type PromptProps = ReactRouterPromptProps

/**
 * This component will use react-router prompt to display an alert for client-side navigation,
 * but it also handles page refresh or browser navigation
 *
 * @param props
 */
export function PromptOnNavigate(props: PromptProps) {
    usePromptOnNavigate(props.when)
    return <Prompt {...props} />
}

/**
 * Intercepts beforeUnload event to catch page refresh or browser navigation
 *
 * @param when
 */
export function usePromptOnNavigate(when: boolean | undefined) {
    React.useEffect(() => {
        const alertUser = (e: BeforeUnloadEvent) => {
            e.preventDefault()
            e.returnValue = ''
        }

        if (when) {
            window.addEventListener('beforeunload', alertUser)
        }
        return () => {
            window.removeEventListener('beforeunload', alertUser)
        }
    }, [when])
}
